import { Button, Space } from 'antd'
import CIMSButton from 'components/CIMSButton'
import CIMSDrawer from 'components/CIMSDrawer'
import type { DisabledOptions } from 'hooks/useDisabledOptions'
import { useState } from 'react'
import ConfiguredFieldsForm from '../ConfiguredFieldsForm'
import type { ConfiguredFieldsFormState } from '../../hooks/useConfiguredFields/types'
import type { WorkflowActionDrawerProps } from './types'

/** Presents configured lifecycle fields using the resolved action label and record name. */
function WorkflowActionDrawer({
  operation,
  onCancel,
  onSubmit,
  open,
  pending,
  session,
}: WorkflowActionDrawerProps) {
  const action = session.target.action
  const [formState, setFormState] = useState<ConfiguredFieldsFormState>({
    loading: action.fields.some(({ type }) => type === 'pay_items'),
    valid: false,
  })
  const formId = `workflow-record-${operation}-${session.target.recordId}`
  let disabled: DisabledOptions | undefined
  if (!pending && formState.loading)
    disabled = { disabled: true, reason: 'loading' }
  else if (!pending && !formState.valid)
    disabled = {
      disabled: true,
      reason: {
        why: 'disabled',
        message:
          'Complete required fields and fix any errors before submitting',
      },
    }
  return (
    <CIMSDrawer
      open={open}
      onClose={onCancel}
      title={`${session.target.recordName}: ${action.actionLabel}`}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Space>
            <Button disabled={pending} onClick={onCancel}>
              Cancel
            </Button>
            <CIMSButton
              disabled={disabled}
              form={formId}
              htmlType="submit"
              loading={pending}
              type="primary"
            >
              {action.actionLabel}
            </CIMSButton>
          </Space>
        </div>
      }
    >
      <ConfiguredFieldsForm
        formId={formId}
        onStateChange={setFormState}
        onSubmit={onSubmit}
        pending={pending}
        session={session.fieldSession}
      />
    </CIMSDrawer>
  )
}

export default WorkflowActionDrawer
